/**
 * 截断地址显示，中间用省略号连接
 * @param address 完整地址
 * @param startLength 开始显示的字符数，默认6
 * @param endLength 结尾显示的字符数，默认4
 * @returns 截断后的地址字符串
 */
export const truncateAddress = (address?: string, startLength = 6, endLength = 4): string => {
  if (!address) return '';
  if (address.length <= startLength + endLength) return address;
  return `${address.slice(0, startLength)}...${address.slice(-endLength)}`;
};
